import * as React from 'react';

import { Header } from './Header';
import BodyContainer from './bodyContainer';
import { isNewUi } from '../redesign/uiMode';
import NewShell from '../redesign/shell/NewShell';

//import Home from './Home';

type LayoutProps = {
    tokenHandler: any;
    appEnvironment?: string;
};

// Classic header, or the redesign shell when the user has switched to the new UI (user menu → Try the new UI).
// Both render the same routes, so every screen works in either UI.
export default (props: LayoutProps) => (
    <React.Fragment>
        <div className="loader" id="loading" style={{ display: "none" }}>
            <img src="/images/loading.gif" alt="LOADING" />
        </div>
        {isNewUi() ? (
            <NewShell tokenHandler={props.tokenHandler} appEnvironment={props.appEnvironment}>
                <BodyContainer variant="new" />
            </NewShell>
        ) : (
            <React.Fragment>
                <Header tokenHandler={props.tokenHandler} appEnvironment={props.appEnvironment} />
                <BodyContainer />
            </React.Fragment>
        )}
    </React.Fragment>
);
